<template>
  <v-layout row>
    <v-flex xs12 sm12>
        <v-card class="elavation-1 transparent">
            <v-toolbar class="transparent" flat height="37">
                <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <help-link appId="projects" pageId="creating-task" color="white"></help-link>
            </v-toolbar>
        </v-card>
        <v-card v-if="!loading" class="elavation-1" style="margin:10px 0 5px 0"> 
            <v-toolbar flat height="35px" class="font-weight-bold">
                <span>Project Task Details</span>
                <v-spacer></v-spacer>
                <v-btn v-if="hasEditRights" icon small @click="showEdit" title="Edit Project Task Details">
                    <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn v-if="hasEditRights&&hasNoProjectCharges" icon small @click="dialogDelete=true" title="Delete Project Task Details">
                    <v-icon small>delete</v-icon>
                </v-btn>
            </v-toolbar>
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Project Task Key :
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{project_task.projectTaskKey}}
                        </v-flex>  
                    </v-layout>   
                    <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Task Code :
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{project_task.taskCode}}
                        </v-flex>  
                    </v-layout>    
                    <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Task Name :
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{project_task.taskName}}
                        </v-flex>  
                    </v-layout>
                </v-flex> 
                <v-flex xs12 sm6>
                    <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Total Charges :
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{numFormat.formatNumber(project_task.totalCharges)}} hours
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Created On :
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{project_task.createdOn|moment('MMM DD, YYYY')}}
                        </v-flex>  
                    </v-layout>  
                    <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                        <v-flex xs4 class="text-xs-left">
                            Task Description: 
                        </v-flex>
                        <v-flex xs8 class="font-weight-bold text-xs-left">
                            {{project_task.taskDescription}}
                        </v-flex>  
                    </v-layout>    
                </v-flex>
            </v-layout>
        </v-card>

        <!-- Comments and Updates -->
        <v-layout row wrap>
            <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
            <v-flex xs12 sm6>
                <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedProjectTaskId"></update-history>
            </v-flex>
        </v-layout>
    </v-flex>
    <v-dialog v-model="dialogProjectTask" width="500" persistent>   
        <project-task ref="projectTaskCompRef" @send="getProjects(false)" :dialogProjectTask.sync="dialogProjectTask"></project-task>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="500">
        <v-card class="elavation-1" style="border-radius:4px;"> 
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">Confirm Delete</span>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="text-xs-center">
                <p>Delete this Project Task?</p>
                <p>Note: you will not be able to undo this operation.</p>
            </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn title="Delete" class="red" dark @click="deleteProjectTask" :loading="loading_delete">Delete</v-btn>
                <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
     <!-- status messaging component -->
    <status-messaging :page_query_id="selectedProjectTaskId" @refresh="getProjects(false)"></status-messaging>
  </v-layout>  
</template>
<script>

import projectsApi from '@/api/projects'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'

export default {     
    name: 'ProjectTask',
    metaInfo: {
        title: 'Project Task',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View project task details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'project-task': () => import('@/components/Projects/AddEditProjectTask'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
      return {       
        error: false,
        errorMessage: '',
        loading: false, 
        project_task: null,
        dialogDelete: false,
        loading_delete: false,
        dialogProjectTask: false
      }
    },
    methods: {  
        async deleteProjectTask() {
            try{
                this.loading_delete = true
                const data = {
                    projectTaskId: this.selectedProjectTaskId
                }
                const response = await projectsApi.deleteProjectTask(data)
                if (response.status == 200) {
                    this.loading_delete = false
                    this.$router.push(`/projects/detail/${this.selectedProjectId}`)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.projectTaskCompRef.setData(this.project_task)
            this.dialogProjectTask = true
        },
        async getProjects(show_loading) {
            try{
                this.loading = show_loading
                const response = await projectsApi.getProjectTask(this.selectedProjectTaskId)
                if (response.status == 200) {
                    this.project_task = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.numFormat = numFormat

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Project Task Details'
        })

        this.getProjects(true)
    },
    computed: {
        selectedProjectId() {
            return this.$route.params.id
        },
        selectedProjectTaskId() {
            return this.$route.params.task_id
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        commentsData() {
            if (this.project_task) {
                return {
                    pageQueryId: this.selectedProjectTaskId,
                    pageItemCreatedBy: this.project_task.createdBy,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.projects,
                    notificationTypeId: notificationTypes.task_details
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        hasNoProjectCharges() {
            return this.project_task.totalCharges == 0
        }
    }
  }
</script>